import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { faCalendarAlt } from '@fortawesome/pro-light-svg-icons';
import { AppSettings } from 'src/app/app-settings';

@Component({
  selector: 'app-event-card',
  templateUrl: './event-card.component.html',
  styleUrls: ['./event-card.component.scss']
})
export class EventCardComponent implements OnInit {
  @Input() event: any;
  eventImgURL: string = "";

  public faCalendar = faCalendarAlt;

  constructor(private router: Router) { }

  ngOnInit(): void {
    if (this.event) {
      this.eventImgURL = AppSettings.API_EVENTS_ASSETS + this.event.image_url;
    }
  }



}
